export const firstNameVariable = 'first_name';
export const lastNameVariable = 'last_name';
export const personalizationVariableNames = [firstNameVariable, lastNameVariable];
export const personalizationVariableToken = (name) => `{${name}}`;
export const firstNameVariableToken = personalizationVariableToken(firstNameVariable);
export const lastNameVariableToken = personalizationVariableToken(lastNameVariable);
export const personalizationVariableLabels = {
    [firstNameVariable]: 'firstNameVariable',
    [lastNameVariable]: 'lastNameVariable'
};
export const isPersonalizationVariableName = (name) => personalizationVariableNames.some(variableName => variableName === name);
const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// Same pattern as Ypsilon.Emails.Personalization.remove_variables/1's per-variable
// ~r/[[:blank:]]*\{<name>\}/u — kept in lockstep with it so the preview can never
// drift from what actually happens to the sent content.
const removeTokenPattern = (name) => new RegExp(`[ \\t]*${escapeRegExp(personalizationVariableToken(name))}`, 'g');
const tokenPattern = (name) => new RegExp(escapeRegExp(personalizationVariableToken(name)), 'g');
const fillTokens = (line, samples) => personalizationVariableNames.reduce((line, name) => {
    const sample = samples[name];
    return sample ? line.replace(tokenPattern(name), () => sample) : line.replace(removeTokenPattern(name), '');
}, line);
const removeTokens = (line) => personalizationVariableNames.reduce((line, name) => line.replace(removeTokenPattern(name), ''), line);
const sentencePunctuation = ',.;:!?';
const leadingPunctuationPattern = new RegExp(`^\\s*[${sentencePunctuation}]`);
const punctuationOnlyPattern = new RegExp(`^[\\s${sentencePunctuation}]*$`);
export const startsWithSentencePunctuation = (text) => leadingPunctuationPattern.test(text);
// Sibling variable tokens disappear along with this one, so they don't count as
// surrounding text — and a remainder of only punctuation ("Hallo {first_name},")
// is not mid-sentence either: without the name the line simply ends there.
const surroundingText = (text) => removeTokens(text).trim();
export function buildPersonalizationVariablePreview(editor, pos, samples) {
    const $pos = editor.state.doc.resolve(pos);
    const hasPrecedingText = $pos.parentOffset > 0;
    let tokenizedLine = '';
    let textBefore = '';
    let textAfter = '';
    $pos.parent.forEach((child, offset) => {
        const text = child.type.name === 'personalizationVariable' ? personalizationVariableToken(child.attrs.name) : child.textContent;
        tokenizedLine += text;
        if (offset < $pos.parentOffset) {
            textBefore += text;
        }
        else if (offset > $pos.parentOffset) {
            textAfter += text;
        }
    });
    const isMidSentence = surroundingText(textBefore) !== '' && !punctuationOnlyPattern.test(surroundingText(textAfter));
    return {
        hasPrecedingText,
        isMidSentence,
        withNameLine: fillTokens(tokenizedLine, samples),
        withoutLine: removeTokens(tokenizedLine)
    };
}
